module.exports = __webpack_public_path__ + "img/daruebereinfuegen.2e6ce6a.svg";